import Vue from 'vue'
import App from './App.vue'
import './style.css';
// import 'bootstrap/dist/css'
// import 'bootstrap/dist/css/bootstrap.min.css';

Vue.config.productionTip = false;

[
	'joeran-tesse',
	'description'
].forEach (id => {
  var el = document.getElementById (id);
  if (el) document.body.removeChild (el);
});

new Vue({
  render: h => h(App),
}).$mount('#app')
